module.exports = __webpack_public_path__ + "img/9788901105871.7ec18bda.jpg";